export default {
  csr: {
    name: '',
    fields: {
      thumbnail_path: 'ภาพตัวอย่าง',
      thumbnail: 'ภาพตัวอย่าง',
      title_th: 'หัวข้อ (ไทย)',
      title_en: 'หัวข้อ (อังกฤษ)',
      title: 'หัวข้อ (ไทย/อังกฤษ)',
      description: 'เนื้อหา',
      description_th: 'เนื้อหา (ไทย)',
      description_en: 'เนื้อหา (อังกฤษ)',
      short_description: 'เนื้อหาโดยย่อ',
      short_description_th: 'เนื้อหาโดยย่อ (ไทย)',
      short_description_en: 'เนื้อหาโดยย่อ (อังกฤษ)',
      start: 'เริ่มต้น',
      end: 'สิ้นสุด',
      highlight: 'เด่น',
      type: { label: 'ประเภท', choices: { common: 'ส่วนกลาง', branch: 'สาขา' } },
      attachment_helper: 'อนุญาตเฉพาะไฟล์สกุล pdf ขนาดไม่เกิน 5mb สูงสุด 15 ไฟล์',
      attachment: 'ไฟล์แนบ',
      thumbnail_path_helper: 'รูปภาพตัวอย่าง',
      cover: 'รูปภาพพื้นหลัง',
      images: 'รูปภาพประกอบ',
      images_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 2mb สูงสุด 15 ไฟล์',
      notification: 'แจ้งเตือน',
      // note: 'คอนเทนท์ของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
      note: '',
      no_image: 'ไม่มีภาพตัวอย่าง',
    },
    create: { title: 'สร้างคอนเทนต์ CSR' },
    edit: { title: 'แก้ไข' },
    order: { title: 'จัดการลำดับ' },
    highlight: { title: 'เด่น' },
    approved: { title: 'ที่อนุมัติ' },
    published: { title: 'ที่เผยแพร่' },
    viewer: {
      guest: 'ผู้ใช้ทั่วไป',
      branch: 'name_th',
      from: 'ผู้เข้าชมจาก',
      views: 'จำนวนผู้เข้าชม',
      all_views: 'ยอดเข้าชมทั้งหมด',
    },
  },
}
